import React from 'react';
import { Card, Grid, Typography, Link, CircularProgress, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const ExternalReportPage = ({ report, loading, error, showContainer = false, currentDataProductId }) => {
    if (loading) {
        return (
            <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                style={{ 
                    marginTop: '30px',
                    height: showContainer ? 'calc(100vh - 100px)' : '400px'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Grid item xs={12}>
                <Card variant="outlined" sx={{ padding: '20px', backgroundColor: 'error.light' }}>
                    <Typography variant="h6" color="error">
                        Error Loading Report
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {error}
                    </Typography>
                </Card>
            </Grid>
        );
    }

    if (!report) {
        return null;
    }

    return (
        <>
            <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                <Card 
                    variant="outlined" 
                    sx={{ 
                        padding: '20px', 
                        // backgroundColor: 'primary.light' 
                    }}
                >
                    <Typography variant="h4" gutterBottom>
                        {report.title}
                    </Typography>
                    {report.description && (
                        <Typography variant="body1" paragraph color="text.primary">
                            {report.description}
                        </Typography>
                    )}                    
                    {report.mainContact && (
                        <Typography variant="body2" color="text.secondary">
                            Main Contact: {report.mainContact}
                        </Typography>
                    )}
                    {(() => {
                        const filteredProducts = report.relatedDataProducts?.filter(
                            product => !currentDataProductId || product.dataProductIdentifier !== currentDataProductId
                        ) || [];
                        
                        return filteredProducts.length > 0 && (
                            <Typography variant="body2" color="text.secondary">
                                Related Data Products: {filteredProducts.map((product, index) => (
                                    <React.Fragment key={index}>
                                        {index > 0 && ', '}
                                        <Link component={RouterLink} to={`/explore/data-products/${encodeURIComponent(product.dataProductIdentifier)}`} underline="hover">
                                            {product.dataProductIdentifier}
                                        </Link>
                                    </React.Fragment>
                                ))}
                            </Typography>
                        );
                    })()}
                </Card>
            </Grid>
            <Grid item xs={12} sx={{ marginBottom: '30px' }}>
                <Card variant="outlined" sx={{width:"100%", height: 'calc(100vh - 250px)', minHeight: '600px' }}>  
                    <iframe 
                        title={report.title} 
                        width="100%" 
                        height="100%" 
                        src={report.reportEmbedUrl}
                        allowFullScreen={true}
                        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads"
                    />
                </Card>
            </Grid>
        </>
    );
};

export default ExternalReportPage;
